import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {getRefinements, pushEdapEvent} from '../../../utils/edap';

import {showDatesPopup} from '../../../actions/search';
import {UNREFINED_KEY} from '../../../utils/listings';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';

function performClick({
    actionLocation = 'properties-module',
    dispatch,
    eventrefinements = '27',
    lbsId,
    refinementKey,
    serpUrlFilters,
    modalTitle,
    datesPopupAction,
}) {
    return (evt) => {
        evt.preventDefault();

        const eventaction = 'card-search-click';

        pushEdapEvent('content_tile.selected', {
            action_location: actionLocation,
            event_refinements:
                eventrefinements && parseInt(eventrefinements, 10)
                    ? `filter:${eventrefinements}`
                    : eventrefinements,
            event_action: eventaction,
            event_lbsuuid: lbsId,
        });

        dispatch(
            showDatesPopup({
                searchLink: false,
                actionLocation,
                eventrefinements,
                goToSerpAction: datesPopupAction,
                refinementKey,
                serpUrlFilters,
                title: modalTitle,
                tripleId: null,
            })
        );
    };
}

export class SeeMorePropertiesRatioCardComponent extends PureComponent {
    render() {
        const {
            actionLocation,
            dispatch,
            propertyType,
            segmentKey,
            serpUrlFilters,
            title,
            lastCardUrl,
            lbsId = '',
            imageSrc,
            aspectRatio = '4x3',
            eventRefinements,
            datesPopupAction,
        } = this.props;
        const eventrefinements =
            eventRefinements ||
            getRefinements({
                propertyType,
                refinementKey: segmentKey,
            });

        return (
            <a
                href={lastCardUrl}
                onClick={performClick({
                    dispatch,
                    actionLocation,
                    eventrefinements,
                    lbsId,
                    refinementKey: segmentKey,
                    segmentKey,
                    serpUrlFilters,
                    title,
                    datesPopupAction,
                })}
            >
                <div className="SeeMorePropertiesCard">
                    <AspectRatioCard aspectRatio={aspectRatio} key={imageSrc}>
                        <div
                            data-slot={'figure'}
                            className="SeeMorePropertiesCard__content bg-brand"
                        >
                            <div className="SeeMorePropertiesCard__overlay" />
                        </div>
                    </AspectRatioCard>
                    <h4 className="SeeMorePropertiesCard__title">{title}</h4>
                </div>
            </a>
        );
    }
}

export function mapStateToProps(state) {
    return {
        propertyType: state.destination.propertyType,
        inventoryCount:
            state.destination.segmentFilters.inventoryCount ||
            state.destination.inventoryCount,
        abacus: state.abacus,
        segmentKey: state.destination.segmentFilters.key || UNREFINED_KEY,
        serpUrlFilters: state.destination.serpUrlFilters,
        title: state.modules.searchMessages.title,
    };
}

export const SeeMorePropertiesRatioCard = connect(mapStateToProps)(
    SeeMorePropertiesRatioCardComponent
);

SeeMorePropertiesRatioCard.displayName = 'SeeMorePropertiesRatioCard';

export default SeeMorePropertiesRatioCard;
